import { PurplePurple60 } from '@sequencehq/core-components'

import { developerLogGroup, type DeveloperLogEntry } from 'lib/developerLog'

export const cubeDeveloperLogGroup = ({
  label = CUBE_LOG_LABEL,
  summary,
  entries,
  badgeBackgroundColor = PurplePurple60
}: {
  label?: string
  summary: string
  entries: DeveloperLogEntry[]
  badgeBackgroundColor?: string
}) =>
  developerLogGroup({
    label,
    summary,
    entries,
    badgeBackgroundColor
  })

export const CUBE_LOG_LABEL = 'Cube'
